const idealTextColor = function () {
    const bgColor = getComputedStyle(document.body).getPropertyValue('--primaryColor')
    let textColor
    const luminance = getLuminance(bgColor)
    if (luminance > 0.5) {
        textColor = '#000000' // Set text color to black
    } else {
        textColor = '#FFFFFF' // Set text color to white
    }

    return textColor
}

function getLuminance (color) {
    // Convert hex color to RGB
    const rgb = hexToRgb(color)
    // Calculate relative luminance
    const r = adjustGamma(rgb.r / 255)
    const g = adjustGamma(rgb.g / 255)
    const b = adjustGamma(rgb.b / 255)
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
    return luminance
}

// Convert a hex color to an RGB object
function hexToRgb (hex) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null
}

// Adjust the gamma of a color component
function adjustGamma (component) {
    if (component <= 0.03928) {
        return component / 12.92
    } else {
        return Math.pow((component + 0.055) / 1.055, 2.4)
    }
}

function validateCPF (cpf) {
    cpf = cpf.replace(/[^\d]/g, '') // Remove non-numeric characters

    if (cpf.length !== 11 || !/^\d{11}$/.test(cpf)) return false // Check length and format

    // Check for known invalid CPFs
    const invalidCPFs = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999'
    ]

    if (invalidCPFs.includes(cpf)) return false

    // Validate the check digits
    let sum = 0
    let mod
    for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i)
    }
    mod = (sum * 10) % 11

    if (mod === 10 || mod === 11) mod = 0

    if (mod !== parseInt(cpf.substring(9, 10))) return false

    sum = 0
    for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i)
    }
    mod = (sum * 10) % 11

    if (mod === 10 || mod === 11) mod = 0

    if (mod !== parseInt(cpf.substring(10, 11))) return false

    return true
}

function removeAccents (str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export { idealTextColor, validateCPF, removeAccents }
